import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../services/alerts.service';
import { UserService } from '../services/user.service';

/**
 * Component for viewing system alerts.
 */
@Component({
  selector: 'alerts',
  templateUrl: './alerts.component.html',
  styleUrl: './alerts.component.css'
})
export class AlertsComponent implements OnInit {
	LOCALIZATION: any;
	
	alerts: any[] = [];
	alertsView: any[] = [];
	alertsMode: string = '';
	
	constructor(
		private ngbModalService: NgbActiveModal,
		private alertsService: AlertsService,
		private userService: UserService
	) {
		this.getAlerts();
		this.processAlerts();
	 }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}
	
	private getAlerts(): void {
		this.alerts = this.alertsService.getAlerts(this.userService.user.username ?? '') || [];
	}
	
	/**
	 * Remove the alert from the current view.
	 */
	closeAlert(index: number): void {
	    this.alerts = this.alertsService.removeAlert(index);
		this.processAlerts();
	}
	
	/**
	 * Filter the alerts view based on the current mode.
	 */	
	toggleMode(mode: string): void {
	    this.alertsMode = this.alertsMode == mode ? "" : mode;
		this.processAlerts();
	}
	
	private processAlerts(): void {
		if (this.alertsMode == "") {
		    this.alertsView = this.alerts;
		}
		else if (this.alertsMode == "info") {
		    this.alertsView = this.alerts.filter(alert => { return alert.status == "info" });
		}
		else if (this.alertsMode == "success") {
		    this.alertsView = this.alerts.filter(alert => { return alert.status == "success" });
		}
		else {
		    this.alertsView = this.alerts.filter(alert => { return alert.status == "danger" });
		}		
	}	
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbModalService.dismiss();
	}	
}
